import * as React from 'react';
import { PaccVideoResultVO } from '@domain/vo/phs/pacc/results/PaccVideoResultVO';
import classNames from 'classnames/bind';
import styles from './v4Result.module.scss';

const cx = classNames.bind(styles);

interface V4ResultProps {
  videoResult: PaccVideoResultVO;
}

const V4Result = ({ videoResult }: V4ResultProps) => {
  const { unreliableYn, comment } = videoResult;

  const statusText = unreliableYn ? '영상 분석 실패' : '영상 분석 완료';

  return (
    <>
      <em className={cx('title')}>영상 종합 분석 결과</em>
      <div className={cx('resultArea')}>
        <div className={cx('statusBox', unreliableYn ? 'warning' : 'good')}>
          <span className={cx('statusText')}>{statusText}</span>
        </div>
        <p className={cx('desc')}>{comment}</p>
      </div>
    </>
  );
};

export default V4Result;
